import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ui from 'redux-ui';
import EmployeeForm from './components/employeeForm';
import {
  updateEmployee,
  requestEmployee,
  navigateBack,
  clearValidationErrors,
  addEventToEmployee,
} from 'actionCreators';
import {
  getWorkroomList,
  getEmployeeErrors,
  getEmployeeById,
} from '../../../../reducers';
import { isEmpty, isEqual, get } from 'lodash';

class EmployeeEdit extends Component {
  constructor(props) {
    super(props);
    this.state = { employeeChanges: {} };
    this.handleSave = this.handleSave.bind(this);
    this.updateEmployeeChanges = this.updateEmployeeChanges.bind(this);
    this.handleCancel = () => { this.props.navigateBack(); };
    this.setSuccessMessage = () => {
      this.props.updateUI('successMessage', 'Changes have been saved');
    };
  }

  componentDidMount = () => this.props.requestEmployee(this.props.id);

  componentWillUnmount = () => this.props.clearValidationErrors('EMPLOYEE');

  updateEmployeeChanges = (key, value, nestedField = null) => {
    const newEmployeeChanges = Object.assign({}, this.state.employeeChanges);
    if (nestedField) {
      newEmployeeChanges[nestedField] = {
        ...(newEmployeeChanges[nestedField] || {}),
        [key]: value,
      };
    } else newEmployeeChanges[key] = value;
    this.setState({ employeeChanges: newEmployeeChanges });
  }

  handleKey = (employee, employeeChanges, key) => {
    const profileDiff = {};
    const oldVal = key === 'workrooms' ? employee[key].map(w => w.id) : employee[key];
    const newVal = employeeChanges[key];
    if (!isEqual(oldVal, newVal)) profileDiff[key] = [oldVal, newVal];
    return profileDiff;
  }

  handleNestedKey = (employee, employeeChanges, key) => {
    const profileDiff = {};
    const nestedKeys = Object.keys(employeeChanges[key]);
    profileDiff[key] = {};
    nestedKeys.forEach((nKey) => {
      const oldVal = employee[key] ? employee[key][nKey] : '';
      const newVal = get(employeeChanges, [key, nKey], 'null');
      if (!isEqual(oldVal, newVal)) profileDiff[key][nKey] = [oldVal, newVal];
    });
    if (Object.keys(profileDiff[key]).length === 0) delete profileDiff[key];
    return profileDiff;
  }

  createProfileDiff = () => {
    const { employeeChanges } = this.state;
    const { employee } = this.props;
    const profileDiff = {};
    Object.keys(employeeChanges).forEach((key) => {
      const newDiffObj = typeof employeeChanges[key] === 'object' && !Array.isArray(employeeChanges[key]) ?
        this.handleNestedKey(employee, employeeChanges, key) :
        this.handleKey(employee, employeeChanges, key);
      Object.assign(profileDiff, newDiffObj);
    });
    return profileDiff;
  }

  handleSave = (employee) => {
    const profileDiff = this.createProfileDiff();
    const eventProps = {
      name: 'Update Profile',
      kind: 'update_profile',
      data: { updates: profileDiff },
    };
    this.props.updateEmployee(employee, this.setSuccessMessage)
      .then(() => (!isEmpty(profileDiff) ?
        this.props.addEventToEmployee(employee.id, eventProps) : null));
  }

  render = () => {
    const { employee, errors, loading, workrooms, user } = this.props;
    return (
      !loading
        ? <EmployeeForm
          employee={employee}
          errors={errors}
          onSave={this.handleSave}
          updateDiff={this.updateEmployeeChanges}
          onCancel={this.handleCancel}
          workrooms={workrooms}
          user={user}
        />
        : <p>Loading...</p>
    );
  }
}

EmployeeEdit.propTypes = {
  id: PropTypes.number,
  updateUI: PropTypes.func,
  updateEmployee: PropTypes.func,
  addEventToEmployee: PropTypes.func,
  navigateBack: PropTypes.func,
  requestEmployee: PropTypes.func,
  clearValidationErrors: PropTypes.func,
  loading: PropTypes.bool,
  employee: PropTypes.object,
  errors: PropTypes.object,
  workrooms: PropTypes.array,
  user: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const employee = getEmployeeById(state)[id];
  return {
    id,
    employee,
    errors: getEmployeeErrors(state) || {},
    loading: employee ? employee.loading : true,
    workrooms: getWorkroomList(state),
    user: state.user,
  };
};

export default ui()(connect(
  mapStateToProps, {
    requestEmployee,
    clearValidationErrors,
    updateEmployee,
    navigateBack,
    addEventToEmployee },
)(EmployeeEdit));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/employees/employeeEdit.jsx